<template>
  <div>
    <div id="hpc">
      <div id="lbimg">
        <el-carousel id="hCarousel" :interval="5000" arrow="always">
            <el-carousel-item style="width: 100%;height: 100%;">
                <img style="width: 100%;height: 100%;" src="../assets/img/tout/wenchuang.jpg">
            </el-carousel-item>
            <el-carousel-item style="width: 100%;height: 100%;">
                <img style="width: 100%;height: 100%;" src="../assets/img/wench/04.jpg">
            </el-carousel-item>
            <el-carousel-item style="width: 100%;height: 100%;">
                <img style="width: 100%;height: 100%;" src="../assets/img/wench/05.jpg">
            </el-carousel-item>
            <el-carousel-item style="width: 100%;height: 100%;">
                <img style="width: 100%;height: 100%;" src="../assets/img/wench/06.jpg">
            </el-carousel-item>
        </el-carousel>
      </div>
      <div id="wclist">
        <router-link v-for="(item, index) in tableData" :key="index" :style="wconly" tag="div" :to="{path:'/wenchuangDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div :style="{height: wcimgheight}">
            <img class="imgs" style="width: 100%;height: 100%;transform: scale3d(1, 1, 1); transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;object-fit: cover;"
              :src="item.images">
          </div>
          <div :style="wcdic">
            <div style="font-size:18px;text-align: left;margin-left: 10px;margin-right: 10px;">{{item.titleStr}}</div>
            <div style="color: #FF0000;text-align: left;margin-left: 10px;margin-right: 10px;"><span style="font-size: 15px;">￥</span><span
                style="font-size:20px;font-weight: 800;">{{item.price}}</span></div>
          </div>
        </router-link>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div id="hmobile">
      <div style="height: 140px;"><img style="width: 100%;height: 100%;" src="../assets/img/tout/wenchuang.jpg"></div>
      <div style="height: 140px;margin: auto 20px;">
        <router-link style="margin-top: 10px;border-bottom: 1px solid #956f17;padding: 5px;" v-for="(item, index) in tableData"
          :key="index" tag="div" :to="{path:'/wenchuangDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div style="float: left;width: 130px;height: 130px;">
            <img style="width: 100%;height: 100%;transform: scale3d(1, 1, 1); transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;"
              :src="item.images">
          </div>
          <div style="float: left; width: 150px;line-height: 30px;margin-left: 10px;">
            <div style="font-size:18px;text-align: left; color: #956f17;">{{item.title}}</div>
            <div style="color: #FF0000;text-align: left;"><span style="font-size: 15px;">￥</span><span style="font-size:20px;font-weight: 800;">{{item.price}}</span></div>
          </div>
          <div style="clear: both;"></div>
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        len: 0,
        pageTotal: [],
        currentPage: 1,
        pageSize: 100,
        pageNum: 1,
        wconly: {},
        wcdic: {},
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("hmobile").style.display = "block";
        this.mhandleSearch();
      } else {
        document.getElementById("hpc").style.display = "block";
        this.handleSearch();
      }
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.msearch();
      },
      mhandleSearch() {
        this.msearch();
      },
      handleSearch() {
        this.search();
        let eWidth = document.body.clientWidth;
        document.getElementById("hpc").style.width = eWidth + "px";
        document.getElementById("lbimg").style.width = eWidth + "px";
        document.getElementById("lbimg").style.height = eWidth * 0.35 + "px";
        document.getElementById("hCarousel").style.width = eWidth + "px";
        document.getElementById("hCarousel").style.height = eWidth*0.35 + "px";
        document.getElementById("wclist").style.width = eWidth * 0.9 + "px";
        this.wconly.float = "left";
        this.wconly.width = (eWidth * 0.9) / 4 - 12 + "px";
        this.wconly.height = eWidth * 0.3 + "px"
        this.wconly.marginLeft = "10px";
        this.wconly.marginTop = "25px";
        this.wconly.background = "#ffffff";
        this.wconly.cursor = "pointer";
        this.wcimgheight = eWidth * 0.22 + "px";
        this.wcdic.height = eWidth * 0.08 + "px";
        this.wcdic.lineHeight = eWidth * 0.04 + "px";
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/literary/literaryAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          that.len = that.tableData.length;
          for (let i = 0; i < that.tableData.length; i++) {
            if (that.tableData[i].title.length > 10) {
              that.tableData[i].titleStr = (that.tableData[i].title).substring(0, 10) + "...";
            } else {
              that.tableData[i].titleStr = that.tableData[i].title;
            };
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      msearch: function() {
        let that = this;
        let url = this.HOST + '/api/v1/literary/literaryAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          that.len = that.tableData.length;
          for (let i = 0; i < that.tableData.length; i++) {
            if (that.tableData[i].title.length > 10) {
              that.tableData[i].titleStr = (that.tableData[i].title).substring(0, 10) + "...";
            } else {
              that.tableData[i].titleStr = that.tableData[i].title;
            };
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #hpc {
    display: none;
  }

  #hmobile {
    display: none;
    width: 100%;
  }

  #hpc {
    width: 90%;
    background: rgb(229, 221, 209);
  }

  #wclist {
    margin: 0 auto;
  }

  #hpc {
    padding-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Wenchuang.vue